<template>
  <div>
    <scroll-button :isFixed="false" :size="36" />
  </div>
</template>

<script>
import ScrollButton from './ScrollButton.vue';
export default {
  components: {
    ScrollButton
  }
};
</script>